// @ts-nocheck
import { Link, Outlet, useNavigate, useRouteLoaderData } from "react-router-dom";

import UserInfo from "../common/userInfo";

export default function FleetDetail() {
    const fleet = useRouteLoaderData("fleet");
    const navigate = useNavigate();

    return (
        <div className="pt-3">
                <div className="cssSeperateWhenWide ps-3">
                    <div className="flex-grow-1 maxWidth-50 me-3">
                        <table className="table table-fixed">
                            <tbody className="noTableTopBorder">
                                <tr>
                                    <th>ID</th>
                                    <td>{fleet.id}</td>
                                </tr>
                                <tr>
                                    <th>Truck Number</th>
                                    <td>{fleet.truckNumber}</td>
                                </tr>
                                <tr>
                                    <th>Fleet Type</th>
                                    <td>{fleet.fleetType}</td>
                                </tr>
                                <tr>
                                    <th>Is Hot Patch</th>
                                    <td>{fleet.isHotPatch}</td>
                                </tr>
                                <tr>
                                    <th>Created At</th>
                                    <td>{fleet.createdAt}</td>
                                </tr>
                                <tr>
                                    <th>Creator</th>
                                    <td>
                                        {fleet.creatorId ? (
                                            <UserInfo id={fleet.creatorId} name={fleet.creator} />
                                        ) : null}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Updated At</th>
                                    <td>{fleet.updatedAt}</td>
                                </tr>
                                <tr>
                                    <th>Updater</th>
                                    <td>
                                        {fleet.updaterId ? (
                                            <UserInfo id={fleet.updaterId} name={fleet.updater} />
                                        ) : null}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="flex-grow-1 maxWidth-50 me-3">
                        <table className="table table-fixed">
                            <tbody className="noTableTopBorder">
                                <tr>
                                    <th>Void</th>
                                    <td>{fleet.void}</td>
                                </tr>
                                <tr>
                                    <th>Void Reason</th>
                                    <td>{fleet.voidReason}</td>
                                </tr>
                                <tr>
                                    <th>Validate Reason</th>
                                    <td >{fleet.validateReason}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="my-3">
                    <div className="d-flex gap-2">
                        <Link className="btn btn-success" to="Edit">
                            Edit
                        </Link>
                        <button
                            type="button"
                            className="btn btn-outline-secondary ms-auto"
                            onClick={() => navigate("/Fleets")}
                        >
                            Back
                        </button>
                    </div>
                </div>
                <Outlet />
        </div>
    );
}
